import { TrackerEvent, TrackerInstance } from './tracker-factory';

class KissmetricsAdapter implements TrackerInstance {
  // @ts-ignore
  private config: any;

  constructor(config?: any) {
    this.config = config;
  }

  public report(event: TrackerEvent) {
    return new Promise<boolean>(resolve => {
      try {
        window._kmq.push(['record', event.name, event.value]);
        resolve(true);
      } catch (e) {
        console.error(e);
        resolve(false);
      }
    });
  }
}

export default KissmetricsAdapter;
